const defaultCountry = {
  code: 'GB',
  name: 'United Kingdom',
  currency: {
    code: 'GBP',
    name: 'Pound Sterling',
    decimals: 2,
    isSupported: true,
    symbol: '£',
  },
  ageRatingBoard: 'PEGI',
  taxRate: 20,
  taxRates: { book: 0, comic: 0, 'gift-card': 0 },
  isGdprCompliant: true,
  isBanned: false,
  isBlocked: false,
};

const xboxIncluded = [
  'US',
  'GB',
];

function decorateCountryData(country) {
  const returnObject = { ...country };

  returnObject.xboxAvailable = xboxIncluded.includes(country.code);

  // Old flat format for compatibility
  returnObject.currencyCode = country.currency.code;
  returnObject.currencyName = country.currency.name;
  returnObject.nativeCurrencyCode = country.nativeCurrency?.code;
  returnObject.nativeCurrencyName = country.nativeCurrency?.name;

  return returnObject;
}

const countryData = decorateCountryData(window.countryData || defaultCountry);

export const {
  code: countryCode, // Use old variable names for simplicity/context
  name: countryName, // Use old variable names for simplicity/context
  isGdprCompliant,
  xboxAvailable,
  ageRatingBoard,
  currency, // Full object
  currencyCode,
  currencyName,
  nativeCurrencyCode,
  nativeCurrencyName,
  nativeCurrency, // Full object
  taxRate,
  isBanned,
  isBlocked,
} = countryData;

export default countryData;
